<template>
  <div id="app">
    <van-nav-bar title="方便职工"
    
    right-text="返回"
    @click-right="onClickRight"
     />
    <div class="">
      <ul>
        <li class="card">
          <a class="card-title" href="" title="人事指南"
            ><i class="iconfont icon-renqun"></i>
            <p>人事指南</p></a
          >
          <div class="header-1">
            <h2>卡证补办指南:</h2>
          </div>
          <ul class="icon-list">
            <li>
              <a
                href="http://220.248.45.45:18080/HRGuide/gongwupiao1.html"
                title="公务票（工作证）"
                ><svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-gongzuozheng"></use></svg
                >公务票 （工作证）</a
              >
            </li>
            <li>
              <a
                href="http://220.248.45.45:18080/HRGuide/gongzika.html"
                title="工资卡"
                ><svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-gongziqiarenzheng"></use></svg
                >工资卡</a
              >
            </li>
            <li>
              <a
                href="http://220.248.45.45:18080/HRGuide/fanka.html"
                title="就餐卡"
                ><svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-canyin"></use></svg
                >就餐卡</a
              >
            </li>
          </ul>
          <div class="header-1">
            <h2>证明文件办理指南:</h2>
          </div>
          <ul class="icon-list">
            <li>
              <a
                href="http://220.248.45.45:18080/HRGuide/zaizhizhengming.html"
                title="在职证明"
                ><svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-zaizhizhengming"></use></svg
                >在职证明</a
              >
            </li>
            <li>
              <a
                href="http://220.248.45.45:18080/HRGuide/shouruzhengming.html"
                title="收入证明"
                ><svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-shouruzhengming"></use></svg
                >收入证明</a
              >
            </li>
          </ul>
          <div class="header-1">
            <h2>其他事项办理指南:</h2>
          </div>
          <ul class="icon-list">
            <li>
              <a
                href="http://220.248.45.45:18080/HRGuide/baby.html"
                title="婴幼儿托费办理指南"
                ><svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-yingyouer-"></use></svg
                >婴幼儿托费办理指南</a
              >
            </li>
          </ul>
          <div class="header-1">
            <h2>离职/退休员工:</h2>
          </div>
          <ul class="icon-list">
            <li>
              <a
                href="http://220.248.45.45:18080/HRGuide/lizhi.html"
                title="离职办理指南"
                ><svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-yuangonglizhishenqingbiao"></use></svg
                >离职办理指南</a
              >
            </li>
          </ul>

          <ul class="btn-list">
            <li class="btn-green">
              <a
                href="http://www.962222.net/ytjApp/wechatm/Rplogin.jsp"
                title="社保卡申领"
                >社保卡申领</a
              >
            </li>
            <li class="btn-red">
              <a
                href="http://person.shgjj.com/gjjweb/wl/h5/index.html#/root/login"
                title="公积金查询"
                >公积金查询<i class="iconfont icon-jumin"></i
              ></a>
            </li>

            <li class="btn-blue">
              <a
                href="http://shanghaicity.openservice.kankanews.com/public/social/sblogin"
                title="养老保险查询"
                >养老保险查询<i class="iconfont icon-shangwu"></i
              ></a>
            </li>
            <li class="btn-orange">
              <a
                href="http://shanghaicity.openservice.kankanews.com/public/civil/shyb"
                title="医疗保险查询"
                >医疗保险查询<i class="iconfont icon-huzhao1"></i
              ></a>
            </li>
            <li class="btn-green">
              <a
                href="https://etax.shanghai.chinatax.gov.cn/webchart/m_fb_login.xhtml"
                title="个税查询"
                >个税查询<i class="iconfont icon-jumin1"></i
              ></a>
            </li>
          </ul>
        </li>
      </ul>
      <ul>
        <li class="card">
          <a class="card-title" href="" title="交通出行"
            ><i class="iconfont icon-renqun"></i>
            <p>交通出行</p></a
          >
          <ul class="icon-list">
            <li>
              <a
                href="http://shanghaicity.openservice.kankanews.com/public/bus"
                title="实时公交"
                ><svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-gongjiao"></use></svg
                >实时公交</a
              >
            </li>
            <li>
              <a
                href="https://shanghaicity.openservice.kankanews.com/public/road/index"
                title="路况查询"
                ><svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-toggle"></use></svg
                >路况查询</a
              >
            </li>
            <li>
              <a
                href="https://shanghaicity.openservice.kankanews.com/public/tour/index"
                title="景区客流"
                ><svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-iconset0210"></use></svg
                >景区客流</a
              >
            </li>
            <li>
              <a
                href="http://app.shanghaiairport.com/airport_platform/html5/html5/html/shjc/shjc.html"
                title="航班查询"
                ><svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-ly_hangban"></use></svg
                >航班查询</a
              >
            </li>
          </ul>
          <ul class="btn-list">
            <li class="btn-green">
              <a
                href="https://shanghaicity.openservice.kankanews.com/public/traffic/jtkye"
                title="交通卡余额"
                ><i class="iconfont icon-zhengjian"></i>交通卡余额</a
              >
            </li>
            <li class="btn-red">
              <a
                href="https://shanghaicity.openservice.kankanews.com/public/traffic/login"
                title="交通违法"
                >交通违法<i class="iconfont icon-jumin"></i
              ></a>
            </li>

            <li class="btn-blue">
              <a
                href="http://bmxx.swj.sh.gov.cn/shswhy/shfxqyy.asp"
                title="道路积水查询"
                >道路积水<i class="iconfont icon-shangwu"></i
              ></a>
            </li>
            <li class="btn-orange">
              <a
                href="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx920015b9d67461c3&redirect_uri=http%3A%2F%2Fweixin.shia.org.cn%2Frestservices%2Fshkcypwx%2FwxGetOpenId%2Fquery%3Furl%3Dhttp%3A%2F%2Fkcyp-h5.shia.org.cn%2Fshkckpweb%2Fshkckpweb_firstpage&response_type=code&scope=snsapi_base&state=longrise#wechat_redirect"
                title="快处易赔"
                >快处易赔<i class="iconfont icon-huzhao1"></i
              ></a>
            </li>
          </ul>
        </li>
      </ul>

      <ul>
        <li class="card">
          <a class="card-title" href="" title="便捷生活"
            ><i class="iconfont icon-renqun"></i>
            <p>便捷生活</p></a
          >
          <ul class="btn-list" style="margin-top:20px;">
            <li class="btn-green">
              <a
                href="https://shanghaicity.openservice.kankanews.com/public/default/Weather"
                title="上海天气"
                >上海天气<i class="iconfont icon-jumin1"></i
              ></a>
            </li>
            <li class="btn-red">
              <a
                href="http://shanghaicity.openservice.kankanews.com/public/aqi/index"
                title="空气质量"
                >空气质量<i class="iconfont icon-jumin"></i
              ></a>
            </li>

            <li class="btn-blue">
              <a
                href="http://sqggfw.mzj.sh.gov.cn/Weixin/ServiceDistrict_SH.aspx"
                title="社区事务受理"
                >社区事务受理<i class="iconfont icon-shangwu"></i
              ></a>
            </li>
            <li class="btn-orange">
              <a
                href="http://marry.mzj.sh.gov.cn/minz-app-front/f/wap/shanghaiBook"
                title="结婚登记预约"
                >结婚登记预约<i class="iconfont icon-huzhao1"></i
              ></a>
            </li>
            <li class="btn-green">
              <a
                href="http://shanghaicity.openservice.kankanews.com/public/civil/inout"
                title="出入境办证"
                >出入境办证<i class="iconfont icon-jumin1"></i
              ></a>
            </li>
            <li class="btn-red">
              <a
                href="http://shanghaicity.openservice.kankanews.com/public/cy/index"
                title="餐饮脸谱查询"
                >餐饮脸谱查询<i class="iconfont icon-jumin"></i
              ></a>
            </li>

            <li class="btn-blue">
              <a
                href="http://trash.lhsr.cn/sites/feiguan/trashTypes_3/7FAC964C.aspx"
                title="垃圾分类查询"
                >垃圾分类查询<i class="iconfont icon-shangwu"></i
              ></a>
            </li>
            <li class="btn-orange">
              <a
                href="http://act.shanghaicity.openservice.kankanews.com/iloveshanghai/2015/zhaosheng/indexnew.html"
                title="入学信息查询"
                >入学信息查询<i class="iconfont icon-huzhao1"></i
              ></a>
            </li>
            <li class="btn-green">
              <a
                href="https://shanghaicity.openservice.kankanews.com/citizen-html/index.html"
                title="重名查询"
                >重名查询<i class="iconfont icon-jumin1"></i
              ></a>
            </li>
            <li class="btn-red">
              <a
                href="https://shdcapp.wondersgroup.com/yilian-cloud-v2.0-wechat/src/shssdc/shenkangyilian.html?type=1&origin=shrelease"
                title="医院报告查询"
                >医院报告查询<i class="iconfont icon-jumin"></i
              ></a>
            </li>

            <li class="btn-blue">
              <a
                href="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx23a1f784b07b9a74&redirect_uri=https%3a%2f%2fopen.wdjky.com%2flightapp%2findex%3fmenuId%3djzcx%26channelCode%3d10022%26lightAppCode%3d10137%26appid%3dDEF401F2-E798-4870-BDF9-EDFA8C9BA721%26isNewLogin%3d1&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect"
                title="疫苗接种查询"
                >疫苗接种查询<i class="iconfont icon-shangwu"></i
              ></a>
            </li>
          </ul>
        </li>
      </ul>

      <br /><br /><br /><br />
    </div>

    <mTabbar></mTabbar>
  </div>
</template>

<script>
import mTabbar from '../components/TabBar'
import Vue from 'vue';
import { Panel } from 'vant';

Vue.use(Panel);

export default {
  components: {
    mTabbar
  },
  data() {
    return {
    };
  },
  methods: {
    onClickRight(){
      // this.$router.push("/community");
      this.$router.go(-1);
    },

  },
};
</script>

<style lang="less" scoped>
.el-card {
  margin-top: 10px;
  margin-bottom: 6px;
  margin-left: 10px;
  margin-right: 10px;
}
.van-image {
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 10px;
  margin-right: 10px;
}
.header-1 {
  border-bottom: 0;
  border-bottom-color: currentcolor;
  border-bottom-style: none;
  border-bottom-width: 0px;
  overflow: hidden;
}

.header-1 h2 {
  color: #f87b3f;
  font-size: 18px;
  border-left: 3px solid #f87b3f;
  padding-left: 15px;
  font-weight: 700;
  margin: 10px 10px;
  text-align: left;
}

// 以下是service界面css
.card {
  font-size: 16px;
  float: none;
  width: auto;
  height: auto;
  overflow: initial;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 10px;
  margin-right: 10px;

  position: relative;

  background-color: #fff;
  border: 1px solid #ddd;
  border-color: #c50001;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1), z-index 0s 0.12s;
}
.card-title {
  font-size: 18px;
  //
  color: #fff;
}
.card-title p {
  font-size: 16px;
  font-family: "Microsoft YaHei", arial;
  font-weight: bold;
  // text-indent: 35px;//标题向右偏移
  background-color: #c50001;
}

.card .icon-list {
  margin: 8px 15px;
  overflow: hidden;
}
.card .icon-list li {
  float: left;
  width: 25%;
  text-align: center;
  border: 0;
}
.card .icon-list li a {
  display: block;
  padding: 20px 0;
  color: #505050;
  overflow: hidden;
  font-size: 16px;
}

.card .icon-list li a svg {
  position: relative;
  float: none;
  margin: 0 auto 5px;
  width: 30px;
  height: 30px;
  line-height: 30px;
  // border-radius: 50%;
  text-align: center;
  display: block;
  // border: 1px solid #c50001;
  // color: #c50001;
  overflow: hidden;
  transition: 0.6s;
}

.card .btn-list {
  box-sizing: border-box;
  display: block;
  float: none;
  line-height: 24px;
  z-index: auto;
  overflow: hidden;
  margin: 0 10px 0;
}

.card .btn-list li {
  width: 48%;
  margin: 0 1% 15px;
  float: left;
  list-style-type: none;
  padding: 0 2.5px;
}

.card .btn-list li a {
  padding: 10px 5px;
  line-height: 18px;
  position: relative;
  font-size: 14px;

  display: block;
  border-radius: 3px;
  font-weight: bold;
  -webkit-transition: all 0.15s ease-in-out;
  transition: all 0.15s ease-in-out;
  text-decoration: none;
}
.card .btn-list li a svg {
  font-weight: normal;
  float: right;
  margin: 0;
  font-size: 28px;
}

.card .btn-list li.btn-red a {
  background-color: #f8e0da;
  color: #bb1619;
}

.card .btn-list li.btn-green a {
  background-color: #edf6e6;
  color: #7cb434;
}

.card .btn-list li.btn-blue a {
  background-color: #ddecf5;
  color: #51aec8;
}
.card .btn-list li.btn-orange a {
  background-color: #f9efe7;
  color: #f87b3f;
}
</style>
